export default "__VITE_ASSET__CSRY9YkD__"